import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CardGrid from "./Card";
import { Typography } from "@mui/material";

import oliver from "../../images/dg2627/profiler/profiler-optimized/Oliver.jpg";
import nanna from "../../images/dg2627/profiler/profiler-optimized/Nanna.jpg";
import gurr from "../../images/dg2627/profiler/profiler-optimized/Gustav.jpg";
import burbel from "../../images/dg2627/profiler/profiler-optimized/Burbel.jpg";
import melle from "../../images/dg2627/profiler/profiler-optimized/Melle.jpg";
import pino from "../../images/dg2627/profiler/profiler-optimized/Pino.jpg";
import sixten from "../../images/dg2627/profiler/profiler-optimized/Sixten.jpg";
import snollo from "../../images/dg2627/profiler/profiler-optimized/Snollo.jpg";
import ines from "../../images/dg2627/profiler/profiler-optimized/Ines.jpg";
import sofie from "../../images/dg2627/profiler/profiler-optimized/Sofie.jpg";
import totte from "../../images/dg2627/profiler/profiler-optimized/Totte.jpg";
import stella from "../../images/dg2627/profiler/profiler-optimized/Stella.jpg";
import felicia from "../../images/dg2627/profiler/profiler-optimized/Fel.jpg";


// const FAMILYNAME = "Lü tao paœ fi guręt";
const FAMILYNAME = "J’æf ôniãts tiâïn îmitrôü wó’al";

function GroupieGrid() {
  const Groupies = [
    {
      name: "Nanna Linder",
      post: "Chief",
      image: nanna,
      smallImage: nanna,
      email: "gnart@d-group.se",
      age: "2004",
      home: "Stockholm",
      pors: "Datateknik",
      cons: "lightweight",
    },
    {
      name: "Emelie Hedlund",
      post: "Ca$h",
      image: snollo,
      smallImage: snollo,
      email: "snollo@d-group.se",
      age: "2004",
      home: "Stockholm",
      pors: "Informationsteknologi",
      cons: "3.0‰",
    },
    {
      name: "Melvin Manieri",
      post: "Öl & Bar",
      image: melle,
      smallImage: melle,
      email: "melvin.manieri@d-group.se",
      age: "2003",
      home: "Malmö",
      pors: "Informationsteknologi",
      cons: "12,66 sekunder",
    },
    {
      name: "Oliver Regnstrand",
      post: "Webb & ÖverDomaren™",
      image: oliver,
      smallImage: oliver,
      email: "oliver.regnstrand@d-group.se",
      age: "2005",
      home: "Linköping",
      pors: "Informationsteknologi",
      cons: "ragebait",
    },
    {
      name: "Jakob Klingh",
      post: "Werk",
      image: burbel,
      smallImage: burbel,
      email: "jakob.klingh@d-group.se",
      age: "2003",
      home: "Leksand",
      pors: "Datateknik",
      cons: "wasabiärtor",
    },
    {
      name: "Caroline Lind-Val",
      post: "Biljett & U-Lag",
      image: pino,
      smallImage: pino,
      email: "caroline.lind-val@d-group.se",
      age: "2002",
      home: "Stockholm",
      pors: "Datateknik",
      cons: "elsparkcykel",
    },
    {
      name: "Felicia Rogestedt",
      post: "PREvent",
      image: felicia,
      smallImage: felicia,
      email: "felicia.rogestedt@d-group.se",
      age: "2005",
      home: "Stockholm",
      pors: "Datateknik",
      cons: "korv.",
    },
    {
      name: "Gustav Harlin",
      post: "J^9",
      image: gurr,
      smallImage: gurr,
      email: "gustav.harlin@d-group.se",
      age: "2004",
      home: "Luleå",
      pors: "Mjukvaruteknik",
      cons: "español",
    },
    {
      name: "Sixten Lundin",
      post: "Spons",
      image: sixten,
      smallImage: sixten,
      email: "sixten.lundin@d-group.se",
      age: "2005",
      home: "Stockholm",
      pors: "Informationsteknologi",
      cons: "kubbpinne...",
    },
    {
      name: "Ines Frödeberg",
      post: "Trykk",
      image: ines,
      smallImage: ines,
      email: "ines.frodeberg@d-group.se",
      age: "2005",
      home: "Stockholm",
      pors: "Mjukvaruteknik",
      cons: "dumpsterdiving",
    },
    {
      name: "Sofie Ettling",
      post: "Mat & Sittning",
      image: sofie,
      smallImage: sofie,
      email: "sofie.ettling@d-group.se",
      age: "2005",
      home: "Vikbolandet",
      pors: "Informationsteknologi",
      cons: "lite vilse...",
    },
    {
      name: "Stella Sjöberg",
      post: "Trykk",
      image: stella,
      smallImage: stella,
      email: "stella.sjoberg@d-group.se",
      age: "2005",
      home: "Stockholm",
      pors: "Informationsteknologi",
      cons: "snusmumrik",
    },
    {
      name: "Theodor Stiebel",
      post: "Personal",
      image: totte,
      smallImage: totte,
      email: "theodor.stiebel@d-group.se",
      age: "2004",
      home: "Stockholm",
      pors: "Datateknik",
      cons: "åh jorge",
    },
  ];

  return (
    <Box sx={{ mt: 10, textAlign: "center", overflowX: "hidden" }}>
      <Grid container>
        <Grid item xs={12} md={4} sx={{ p: { xs: 1, md: 2 } }} /* About card */>
          <Grid
            sx={{
              display: { xs: "none", md: "inline" },
            }} /* Om D-group försvinner på liten skärm */
          >
            <Typography
              variant="h2"
              gutterBottom
              fontWeight={"bold"}
              color={"#E5398D"}
            >
              Om D-Group
            </Typography>
            <Typography variant="h6" gutterBottom>
              D-Group är D-sektionens eminenta festeri. Vi har funnits sedan
              världen var svart-vit och popcorn inte gick att göra i micron.
              Innan dess låg vi i mammas kära mage och smed planer om
              världsherravälde genom pilkastning, ölhäfv och självrökande
              cigaretter. Vi tycker om att ha kul!
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: { xs: "inline", md: "none" },
            }} /* Vilka är vi syns på liten skräm */
          >
            <Typography
              variant="h2"
              gutterBottom
              fontWeight={"bold"}
              color={"#E5398D"}
            >
              Vilka är vi?
            </Typography>
            <Typography variant="h6" gutterBottom>
              Tjena Tjena! Vi är familjen {FAMILYNAME}, för att veta mer om en
              specifik medlem är det bara att klicka på bilden!
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} md={4} sx={{ p: { xs: 1, md: 2 } }} /* Chief Card */>
          <CardGrid user={Groupies[0]} />
        </Grid>
        <Grid item
          xs={12}
          md={4}
          sx={{
            p: { xs: 1, md: 2 },
            display: { xs: "none", md: "inline" },
          }} /* Click about Card  förvvinner på liten skräm*/
        >
          <Typography
            variant="h2"
            gutterBottom
            fontWeight={"bold"}
            color={"#E5398D"}
          >
            Vilka är vi?
          </Typography>
          <Typography variant="h6" gutterBottom>
            Tjena Tjena! Vi är familjen {FAMILYNAME}, för att veta mer om en
            specifik medlem är det bara att klicka på bilden!
          </Typography>
        </Grid>
        {Groupies.slice(1).map((user) => (
          <Grid item xs={12} md={4} sx={{ p: { xs: 1, md: 2 } }} key={user.email}>
            <CardGrid user={user} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default GroupieGrid;
